import { jsx as _jsx } from "react/jsx-runtime";
import { QueryProvider } from "./query-client.js";
export function APIProvider(props) {
    return _jsx(QueryProvider, { children: props.children });
}
